import { NavigationListRoot, NavigationListGroup, NavigationListLabel, NavigationListHeading, NavigationListItem } from './navigation-list-primitives';

const NavigationList = {
  Group: NavigationListGroup,
  Heading: NavigationListHeading,
  Item: NavigationListItem,
  Label: NavigationListLabel,
  Root: NavigationListRoot,
} as const;

export { NavigationList };
